import {GoToDestinationAction, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalGoToDestinationActionGoTo} from "./PortalGoToDestinationActionGoTo";
import {PortalActionType} from "./PortalActionEvent";

export class PortalGoToDestinationAction extends GoToDestinationAction implements Parameter {
	public _goTo?: PortalGoToDestinationActionGoTo;
	public type?: PortalActionType;

	constructor(data: any) {
		super(data);

		this._goTo = PortalGoToDestinationActionGoTo.fromJson(data?.goTo);
		this.type = FunctionHelper.exists(data?.type) ? data.type : PortalActionType.None;
	}

	public static getTypeDefault(): PortalActionType {
		return PortalActionType.None;
	}

	public static fromJson(data: any): PortalGoToDestinationAction {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalGoToDestinationAction(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'type': this.type
		};
	}

	public clone(): PortalGoToDestinationAction {
		return PortalGoToDestinationAction.fromJson(this.toJson());
	}
}